import type { AdConsent } from './types';
const contextual = (): AdConsent => ({ ads: false, networkIds: [] });
let current = contextual();
const subscribers = new Set<(consent: AdConsent) => void>();

/** Accept only a CMP's explicit network grants. Nothing here infers or stores consent. */
export function cleanConsent(value: unknown): AdConsent {
  const input = value && typeof value === 'object' ? value as Partial<AdConsent> : {};
  const privacy = navigator as Navigator & { globalPrivacyControl?: boolean };
  if (privacy.globalPrivacyControl === true || navigator.doNotTrack === '1' || input.ads !== true) return contextual();
  return {
    ads: true,
    networkIds: Array.isArray(input.networkIds) ? [...new Set(input.networkIds.filter((id): id is string => typeof id === 'string' && /^[a-z0-9][a-z0-9-]{1,63}$/.test(id)))].slice(0, 100) : [],
    tcf: typeof input.tcf === 'string' && /^[A-Za-z0-9._-]{0,4096}$/.test(input.tcf) ? input.tcf : '',
    gpp: typeof input.gpp === 'string' && /^[A-Za-z0-9._~\-]{0,4096}$/.test(input.gpp) ? input.gpp : '',
  };
}
export const getConsent = () => cleanConsent(current);
export function setConsent(value: unknown): void {
  current = cleanConsent(value);
  for (const subscriber of subscribers) subscriber(getConsent());
}
export function subscribeConsent(subscriber: (consent: AdConsent) => void): () => void {
  subscribers.add(subscriber);
  return () => { subscribers.delete(subscriber); };
}
